import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect, Route } from "react-router";
import { Error403 } from "../Common";
import { ROLE } from "../../constants";
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

class AuthRoute extends Component {
    
    render() {
        const { type, path, user, myInfo } = this.props;

        /* if (type === "guest" && user) 
            return <Redirect to="/home" />;
        else if (type === "private" && !user)  */
        if (type === "private" && !user)
            return <Redirect to="/login" />;
        
        let accessAllow;
        if(    (path === '/home')                                                       //홈
            || (path === '/login')                                                      //로그인
            || (path === '/portalaccess')                                               //포털에서 접속
            || (path === '/logout')                                                     //로그아웃
            || (path === '/dashboard'         && myInfo && myInfo.myRole.dashboard          !== ROLE.NONE)  //대시보드
            || (path === '/opbmng'            && myInfo && myInfo.myRole.opbMng             === ROLE.WRITE) //Display관리
            || (path === '/firmwareMng'       && myInfo && myInfo.myRole.firmwareMng        === ROLE.WRITE) //펌웨어관리
            || (path === '/firmwareAdd'       && myInfo && myInfo.myRole.firmwareMng        === ROLE.WRITE) //펌웨어관리
            || (path === '/firmwareMod'       && myInfo && myInfo.myRole.firmwareMng        === ROLE.WRITE) //펌웨어관리
            || (path === '/firmwareMngDerv'   && myInfo && myInfo.myRole.firmwareMng        === ROLE.WRITE) //펌웨어관리
            || (path === '/opbstate'          && myInfo && myInfo.myRole.opbState           !== ROLE.NONE)  //Display현황
            || (path === '/screenMod'         && myInfo && myInfo.myRole.screenMod          !== ROLE.NONE)  //Display화면편집
            || (path === '/contentsAllMng'    && myInfo && myInfo.myRole.contentsAllMng     === ROLE.WRITE) //통합컨텐츠관리
            || (path === '/contentsMng'       && myInfo && myInfo.myRole.contentsMng        !== ROLE.NONE)  //홍보등록관리
            || (path === '/contentsAdd'       && myInfo && myInfo.myRole.contentsMng        === ROLE.WRITE) //홍보등록관리
            || (path === '/contentsMod'       && myInfo && myInfo.myRole.contentsMng        === ROLE.WRITE) //홍보등록관리
            || (path === '/adMng'             && myInfo && myInfo.myRole.adMng              !== ROLE.NONE)  //마케팅등록관리
            || (path === '/adAdd'             && myInfo && myInfo.myRole.adMng              === ROLE.WRITE) //마케팅등록관리
            || (path === '/adMod'             && myInfo && myInfo.myRole.adMng              === ROLE.WRITE) //마케팅등록관리
            || (path === '/bottomContentsMng' && myInfo && myInfo.myRole.bottomContentsMng  !== ROLE.NONE)  //하단영상등록관리
            || (path === '/bottomContentsAdd' && myInfo && myInfo.myRole.bottomContentsMng  === ROLE.WRITE) //하단영상등록관리
            || (path === '/bottomContentsMod' && myInfo && myInfo.myRole.bottomContentsMng  === ROLE.WRITE) //하단영상등록관리
            || (path === '/noticeMng'         && myInfo && myInfo.myRole.noticeMng          !== ROLE.NONE)  //공지사항관리
            || (path === '/noticeAdd'         && myInfo && myInfo.myRole.noticeMng          === ROLE.WRITE) //공지사항관리
            || (path === '/noticeMod'         && myInfo && myInfo.myRole.noticeMng          === ROLE.WRITE) //공지사항관리
            || (path === '/templateMng'       && myInfo && myInfo.myRole.templateMng        !== ROLE.NONE)  //템플릿등록관리
            || (path === '/templateAdd'       && myInfo && myInfo.myRole.templateMng        === ROLE.WRITE) //템플릿등록관리
            || (path === '/templateMod'       && myInfo && myInfo.myRole.templateMng        === ROLE.WRITE) //템플릿등록관리
            || (path === '/codemng'           && myInfo && myInfo.myRole.codeMng            === ROLE.WRITE) //코드관리
            || (path === '/boardinfo'         && myInfo && myInfo.myRole.boardinfoMng       === ROLE.WRITE) //통합게시판관리
        )
            accessAllow = true;
        else
            accessAllow = false;

        if(!accessAllow){
            if(user && !myInfo) {
                return <Loader
                    type="Rings"
                    color="#00BFFF"
                    height={'50%'}
                    width={'50%'}
                    style={{textAlign: 'center', marginLeft:'auto', marginRight:'auto'}}
                />
            } else 
                return <Error403/>
        }
        
        return <Route {...this.props}/>;
    }
}

function mapState(state) {
    const { authentication, userinfo } = state;
    const { user } = authentication;
    const myInfo = userinfo.item;
    return { user, myInfo };
}

const actionCreators = {
}

export default connect(mapState, actionCreators)(AuthRoute);